import React from "react";
import NavBar from "../NavBar/NavBar";
import UpperHead from "../UpperHead/UpperHead";

const Header = () => {
  return (
    <>
      <UpperHead />
      <NavBar />
    </>
  );
};

export default Header;
